import { HasEyeOffset, SortableOffset } from 'app/map/geometry/cesium/OffsetManager';

// gives us a sorted matrix of any Cesium primitive with an eye offset
export function generate(sortableOffsets: Map<string | number, SortableOffset>): HasEyeOffset[][] {
    const sortedGroupedPrimitives = [];
    const hashMap = _createHashMap(sortableOffsets);

    Object.keys(hashMap).forEach((key) => {
        const sorted = hashMap[key].sort((a, b) => {
            return a.offsetInGroup - b.offsetInGroup;
        });
        sortedGroupedPrimitives.push(sorted);
    });

    // has the form of [[A0, A1, A2, A3], [B1,B2,B3,B4], [C0, C1, C2]]
    return sortedGroupedPrimitives;
}

/*
    Creates us a semi sorted data structure that looks like...
    +-------------------+
    |1: [A1, A0, A3, A2]|
    |2: [B3, B2, B1, B4]|
    |3: [C0, C2, C1]    |
    +-------------------+
    Where A,B,C are the primitives with group indexes and proceeding numbers are the offset in groups
 */
function _createHashMap(sortableOffsets: Map<string | number, SortableOffset>): {
    [key: number]: HasEyeOffset;
} {
    let hashMap = {};

    sortableOffsets.forEach((offset) => {
        if (!hashMap[offset.groupIndex]) {
            hashMap[offset.groupIndex] = [];
        }
        let primitive = offset.primitive;
        primitive.offsetInGroup = offset.offsetInGroup;
        primitive.groupIndex = offset.groupIndex;
        hashMap[offset.groupIndex].push(offset.primitive);
    });

    return hashMap;
}
